import React, {useState} from 'react'

function EditAbonneForm({ abonne, handleUpdateAbonne }) {
  const [nomComplet, setNomComplet] = useState(abonne.nomComplet);
  const [telephone, setTelephone] = useState(abonne.telephone);
  const [typeCarte, setTypeCarte] = useState(abonne.typeCarte);
  const [structure, setStructure] = useState(abonne.structure);
  const [adresse, setAdresse] = useState(abonne.adresse);
  const [email, setEmail] = useState(abonne.email);
  const [job, setJob] = useState(abonne.job);

  const handleSubmit = (e) => {
    e.preventDefault();
    const updatedAbonne = {
      nomComplet,
      email,
      adresse,
      telephone,
      typeCarte,
      structure,
      job,
    };
    handleUpdateAbonne(updatedAbonne);
  };
  
  return (
    <form onSubmit={handleSubmit}>
      <div className="form-row">
        <div className="form-group">
          <label> Nom Complet</label>
          <input
            type="text"
            value={nomComplet}
            onChange={(e) => setNomComplet(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Adresse :</label>
          <input
            type="text"
            value={adresse}
            onChange={(e) => setAdresse(e.target.value)}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label> Téléphone</label>
          <input
            type="text"
            value={telephone}
            onChange={(e) => setTelephone(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Type de Carte:</label>
          <input
            type="text"
            value={typeCarte}
            onChange={(e) => setTypeCarte(e.target.value)}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label> Structure</label>
          <input
          type="text"
          value={structure}
          onChange={(e) => setStructure(e.target.value)}
        />
        </div>
        <div className="form-group">
          <label>Email:</label>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled
          />
        </div>
      </div>
      <div className="form-group">
          <label> Profession</label>
          <input
            type="text"
            value={job}
            onChange={(e) => setJob(e.target.value)}
          />
        </div>
      <div className="flex justify-end">
        <button type="submit">Mettre à jour</button>
      </div>
    </form>
  )
}

export default EditAbonneForm